import ActionButton from '../../../../components/form/ActionButton/ActionButton';
import FaIcon, { faTriangleExclamation } from '../../../../components/icon/FaIcon/FaIcon';
import ModalBase from '../../../../components/ui/ModalBase/ModalBase';
import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { VariantType } from '../../../../types';
import type { WChanceDrawResultGoodsItem } from '../../types';
import WChanceCardHeader from '../WChanceCardHeader/WChanceCardHeader';
import WChancePrizeDetail from '../WChancePrizeDetail/WChancePrizeDetail';
import k2cStyles from './WChanceLinkCard.k2c.module.scss';
import styles from './WChanceLinkCard.module.scss';

export interface WChanceLinkCardProps {
  name: string;
  isBatchType: boolean;
  surveyStatus: {
    key: string;
    linkText: string;
  };
  isNoNeedEntryBatch: boolean;
  isWithoutSurveyBatch: boolean;
  isShowNoNeedEntryMessage: boolean;
  clickButton: () => Promise<void>;
  variant?: VariantType;
  isModalOpen: boolean;
  handleModalClose: () => void;
  handleOptionInputClick: () => void;
  wChanceResults: WChanceDrawResultGoodsItem[];
}

function WChanceLinkCard({
  name,
  isBatchType,
  surveyStatus,
  isNoNeedEntryBatch,
  isWithoutSurveyBatch,
  isShowNoNeedEntryMessage,
  clickButton,
  variant = 'default',
  isModalOpen,
  handleModalClose,
  handleOptionInputClick,
  wChanceResults,
}: WChanceLinkCardProps) {
  const currentStyles = variant === 'k2c' ? k2cStyles : styles;

  return (
    <div className={`${currentStyles.componentStyle} ${utilsStyles.mtSmall}`}>
      <WChancePrizeDetail wChanceResults={wChanceResults} name={name} />
      {isBatchType ? (
        <>
          {isShowNoNeedEntryMessage && (
            <p className={`${currentStyles.surveyCompletedMessage} ${utilsStyles.textSmall}`}>
              アンケート回答済みのため、自動で抽選対象となります
            </p>
          )}
          <div className={`${utilsStyles.mtSmall} ${layoutStyles.centeredBtnWrapper}`}>
            <ActionButton
              size={'large'}
              color={isNoNeedEntryBatch || isWithoutSurveyBatch ? 'gray' : 'primary'}
              onClick={clickButton}
              disabled={isNoNeedEntryBatch || isWithoutSurveyBatch}
              variant={variant}
            >
              {surveyStatus.linkText}
            </ActionButton>
          </div>
        </>
      ) : (
        <>
          <div className={`${utilsStyles.mtSmall} ${layoutStyles.centeredBtnWrapper}`}>
            <ActionButton size={'large'} color={'primary'} onClick={clickButton} variant={variant}>
              {surveyStatus.linkText}
            </ActionButton>
          </div>
        </>
      )}
      <ModalBase isOpen={isModalOpen} onClose={handleModalClose}>
        <div className={currentStyles.optionModal}>
          <div className={`${utilsStyles.centeredVertical}`}>
            <div className={currentStyles.modalHeader}>
              <span className={`${currentStyles.modalIcon} ${utilsStyles.primaryColor} ${utilsStyles.textXLarge}`}>
                <FaIcon icon={faTriangleExclamation} size='lg' />
              </span>
              <span className={`${utilsStyles.textBold} ${utilsStyles.textXLarge}`}>
                {/* アイコンとテキストの間に半角空白一文字の対応を入れたいため、半角空白を入れている */}
                &nbsp;オプション入力が必要な景品があります
              </span>
            </div>
            <p
              className={`${utilsStyles.primaryColor} ${utilsStyles.textBold} ${utilsStyles.mtSmall} ${currentStyles.modalMessage}`}
            >
              Wチャンス賞は
              <span className={currentStyles.breakText}>オプション入力およびアンケート回答後に参加可能です</span>
            </p>
            <div className={`${utilsStyles.mtSmall}`}>
              <ActionButton onClick={handleOptionInputClick} size='large' color='primary' variant={variant}>
                オプション入力をする
              </ActionButton>
            </div>
          </div>
        </div>
      </ModalBase>
    </div>
  );
}

export default WChanceLinkCard;
